import store from "@/redux/store";
import { saveUserInterests } from '@/reducers/User'
import { useState, useEffect } from 'react'
import { Dialog, DialogPanel, DialogTitle, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ChevronRightIcon, ChevronDownIcon, CheckIcon } from '@heroicons/react/20/solid'
import { CalendarDaysIcon, CreditCardIcon, UserCircleIcon } from '@heroicons/react/20/solid'

export function Interest({...props}) {
  const [open, setOpen] = useState(false)
  let [selected, setSelected] = useState(false);
    let interests = props.interests;
    
    
  useEffect(() => {
      if(selected === false) {
          let newSelected = {};
        if(props.user_interests) {            
        Object.keys(props.user_interests).map((pKey) => {
                let parent = props.user_interests[pKey]; 
                let parentKey = parent.key;
                newSelected[parentKey] = {key: parent.key, name: parent.name};
                newSelected[parentKey]["children"] = {};
            Object.keys(parent["children"]).map((childkey) => {
                    let child = parent["children"][childkey]; 

                newSelected[parentKey]["children"][child.key] = {key: child.key, name: child.name};
            });
        });
        }
          setSelected(newSelected);
      }
      
            


//    selected = props.user_interests
    //setSelected(selected);
//    
  }, [])
    
    
    const save =(e) => {
        e.preventDefault();
        
        store.dispatch(saveUserInterests({interests: selected}));
        
        return false;
       }
    const openClose =(e, item) => {
        e.preventDefault();
        if(open == item.key) {
            setOpen(false);
        } else {
            setOpen(item.key);
        }
        
        return false;
        //props.onClose();
    }
    
    const setSelectedItem =(e, item, parent) => {
        e.preventDefault();
        let parentKey = parent.key;
        let childKey = item.key;
        let newSelected = {}; 
        if(!selected) {
            newSelected = {};
        } else {
            newSelected = Object.assign({}, selected);  
        }
        
        
        
        if(newSelected[parentKey] && newSelected[parentKey]["children"][childKey]) {
            delete selected[parentKey]["children"][childKey];
            //newSelected[parentKey][childKey] = false;
            if(Object.keys(newSelected[parentKey]["children"]).length == 0) {
                delete newSelected[parentKey];
            }
        } else {
  
            if(!newSelected[parentKey]) {
                newSelected[parentKey] = {key: parent.key, name: parent.name};
                newSelected[parentKey]["children"] = {};
            }
            if(!(Object.isExtensible(newSelected[parentKey]["children"][childKey])) ) {
                let childObj = Object.assign({}, newSelected[parentKey]["children"][childKey]);
                delete newSelected[parentKey]["children"][childKey];
                newSelected[parentKey]["children"][childKey] = childObj;
            }
            newSelected[parentKey]["children"][childKey] = item;
        }
        newSelected["changeTime"] = (new Date()).valueOf();
        setSelected(newSelected);
        
        return false;
       }
        
        const isChecked = (parent, item) => {
            let isChecked = false;
            if(selected === false) {
                isChecked = (props.user_interests[parent.key] && props.user_interests[parent.key]["children"] && props.user_interests[parent.key]["children"][item.key]);
            } else {
                isChecked = (selected[parent.key] && selected[parent.key]["children"][item.key] && selected[parent.key]["children"][item.key]);
            }
            return isChecked;
        }
  return (
    <div className="mt-5">
     <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-3 lg:grid-cols-5" key={(new Date()).valueOf()}>
      {interests && interests.map((item) => (
        <li key={item.key+((selected["changeTime"]) ? selected["changeTime"] : "")} className="col-span-1 ">
           <div className="flex flex-1 items-top justify-between truncate rounded-r-md border-b border-r border-t border-l rounded-l  border-gray-200 bg-white">
              <div className="flex-1 truncate px-4 py-2 text-sm" >
                <a href={"#"} className="font-medium text-gray-900 hover:text-gray-600" onClick={(e) => {openClose(e, item);}}>
                  {item.name}
                  <p className="text-gray-500">{item.children.length} sub interesses 
                  {(selected[item.key] && Object.keys(selected[item.key]["children"]).length > 0) ? " / "+Object.keys(selected[item.key]["children"]).length+" geselecteerd" : ""} </p>
                </a>
                {open == item.key &&
                <div className="" key={"panel"+((selected["changeTime"]) ? selected["changeTime"] : "")}>
                {item.children && item.children.map((itemchild) => (
                    
                  <div key={itemchild.key+((selected["changeTime"]) ? selected["changeTime"] : "")} 
                   className="flex-1 truncate px-2 py-2 text-sm" onClick={(e) => {setSelectedItem(e, itemchild, item);}}>
                    <div className="flex">
                    <span className="rounded border border-gray-300 text-green-600 focus:ring-green-600 w-5 h-5 mr-2">
                        {isChecked(item, itemchild) &&
                        <CheckIcon aria-hidden="true" className={"h-4 w-5 mt-.5 -ml-.8" + ( isChecked(item, itemchild)  === true) ? "" : "hide"   } />
                        }
                    </span>
                    <a href={"#"} className="font-medium text-gray-900 hover:text-gray-600">
                      {itemchild.name} 
                    </a>
                    </div>
                  </div>                
                  ))}
                  </div>
                  }
              </div>
 <div className="flex-shrink-0 pr-2">
                <button
                  type="button"
                  className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-transparent bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Open options</span>
                  {open == item.key &&
                  <ChevronDownIcon aria-hidden="true" className="h-5 w-5" onClick={(e) => {openClose(e, item);}}/>
                  }
                  {open != item.key &&
                  <ChevronRightIcon aria-hidden="true" className="h-5 w-5" onClick={(e) => {openClose(e, item);}}/>
                  }
                </button>
              </div>              
            </div>
            <div>
            </div>

        </li>
        ))
       }
       </ul>
       <div>
                 <div className="flex items-center justify-end gap-x-6 mt-5 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <button
                onClick={(e) => {save(e);}}     
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
        </div>
       </div>
       )
}        